import { queueTask } from '@sbt-web/utils';

class PageSpeedQueue {
    #queue = [];
    #pulseInstance;
    constructor(pulse) {
        this.#pulseInstance = pulse;
    }
    push(metric) {
        this.#queue.push(metric);
    }
    get length() {
        return this.#queue.length;
    }
    flush(pageType) {
        this.#queue.forEach((metric) => this.#pulseInstance.queueEvent(transformForPulse(metric, pageType)));
        this.#queue = [];
    }
}
const schema = 'http://schema.adevinta.com/events/performance-event.json/18.json';
/**
 * Adapt data for Pulse tracking
 */
const transformForPulse = (trackData, page = '') => {
    const { id, name, startTime, value } = trackData;
    return {
        schema,
        type: 'Send',
        object: {
            id,
            type: 'PerformanceMetric',
            metricName: name,
            metricValue: value,
            metricStartTime: startTime,
            'spt:custom': {
                page,
            },
        },
    };
};
let metricsQueue;
/**
 * Track web-vitals using Pulse tracker
 */
const trackWebVitals = (pulseInstance, metric) => {
    if (!metricsQueue) {
        metricsQueue = new PageSpeedQueue(pulseInstance);
    }
    const dataLayer = window.subito?.dataLayer;
    if (!dataLayer?.page) {
        // If the DataLayer is not ready, queue the metric for later
        metricsQueue.push(metric);
    }
    else {
        // When the DataLayer is ready, we can flush the queued metrics and send
        // the new one directly.
        // The tracking is scheduled, since it can be called repeatedly at the
        // initialisation of the page, and we want to avoid blocking the main
        // thread.
        queueTask(() => {
            const page = dataLayer?.page?.getPageType();
            if (metricsQueue.length > 0) {
                metricsQueue.flush(page);
            }
            pulseInstance.queueEvent(transformForPulse(metric, page));
        }, 'background');
    }
};

export { trackWebVitals as default };
//# sourceMappingURL=page-performance.js.map
